import { Stage, getStage } from 'src/helpers';
import FeedbackModalV2 from './FeedbackModalV2';
import FeedbackModalLegacy from './FeedbackModalLegacy';

interface FeedbackModalProps {
    feedbackModalOpen: boolean;
    setFeedbackModalOpen: (open: boolean) => void;
}

export const USE_V2_STAGES = new Set([
    Stage.TEST,
    Stage.BETA,
    Stage.GAMMA,
    Stage.PROD,
]);

export default function FeedbackModal(props: FeedbackModalProps) {
    const stage = getStage();

    if (USE_V2_STAGES.has(stage)) {
        return <FeedbackModalV2 {...props} />;
    }

    return <FeedbackModalLegacy {...props} />;
}
